<template>
  <nav-bar/>

  <Title content="组织架构"/>
  <img src="~assets/img/instruct/zuzhi.jpg" alt="" style="width: 100%; height: 50vh;">

  <!--教师-->
  <div class="main" v-if="detail.role === 1">
    <p class="title">{{lang === 'zh' ? detail.name + '-' + detail.position : detail.nameEn + '-' + detail.positionEn}}</p>
    <div class="content">
      <div class="imgDiv"><img :src="showUploadImg + detail.img" alt="" ></div>
      <p class="info">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.info : detail.infoEn}}</p>
    </div>
  </div>

  <!--博士生-->
  <div class="main" v-if="detail.role === 0">
    <p class="title">{{lang === 'zh' ? detail.name : detail.nameEn}}</p>
    <div class="content">
      <div class="imgDiv"><img :src="showUploadImg + detail.img" alt="" ></div>
      <p class="info">
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.name + ', ' + detail.grade + '级' + detail.position + '专业, 博士。' : detail.nameEn + ', ' + 'Grade' + detail.grade + detail.positionEn + 'major, doctor.'}}
        <br>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.info : detail.infoEn}}
      </p>
    </div>
  </div>

  <!--硕士生-->
  <div class="main" v-if="detail.role === -1">
    <p class="title">{{lang === 'zh' ? detail.name : detail.nameEn}}</p>
    <div class="content">
      <div class="imgDiv"><img :src="showUploadImg + detail.img" alt="" ></div>
      <p class="info">
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.name + ', ' + detail.grade + '级' + detail.position + '专业, 硕士。' : detail.nameEn + ', ' + 'Grade' + detail.grade + detail.positionEn + 'major, master.'}}
        <br>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.info : detail.infoEn}}
      </p>
    </div>
  </div>


  <Footer/>

  <Animate ref="animate" />
</template>

<script>
  import NavBar from "@/components/common/NavBar";
  import Title from "@/components/common/Title";
  import Footer from "@/components/common/Footer";

  import {ref, reactive, onMounted, getCurrentInstance} from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore, mapGetters } from 'vuex'
  import bus from 'vue3-eventbus'  //引入事件总线
  import { formatDate } from '@/common/utils'
  import Animate from "@/components/common/Animate";

  export default {
    name: "MemberDetils",
    components:{
      NavBar,
      Title,
      Footer,
      Animate
    },
    computed:{
      ...mapGetters(['showUploadImg']),
    },
    setup(){

      let instance = reactive({})
      instance = getCurrentInstance();
      const route = useRoute()
      const router = useRouter()

      const store = useStore()
      let lang = ref('')
      lang.value = store.state.language;
      //监听事件总线
      bus.on('changeLang', type => lang.value = type);

      let detail = reactive({})
      detail = JSON.parse(decodeURIComponent(route.params.obj));


      onMounted(() => {
        //console.log('detail: ', detail)
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })

      return{ route, detail, lang,

      }
    },//setup
  }
</script>

<style scoped lang="less">

  .main{
    margin: 25px 12.5% 0;
    .title{
      padding-top: 20px;
      font-size: 18px;
      color: #333;
      line-height: 65px;
      border-bottom: 1px solid #eaeaea;
    }

    .info{
      margin-bottom: 100px;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }

    .imgDiv{
      text-align: center;
      img{
        margin: 35px 0 15px 0;
        width: 400px;
        height: 560px;
      }
    }


  }

</style>